<template>
    <div v-b-tooltip.hover :title="tooltipText" :class="tagClass">
        <span class="text">
            {{hashtagText}}
        </span>
    </div>
</template>

<script>
    export default {
        name: 'TagStyle',
        props: ['hashtag', 'color', 'selected'],
        data () {
            return {
                colors: {
                    0: 'unused',
                    1: 'overused',
                    2: 'poor',
                    3: 'good',
                    4: 'instagram',
                    5: 'instagram-banned'
                },
                tooltips: {
                    0: 'Do not use this hashtag. Very few people follow it',
                    1: 'Do not use this hashtag. Your posts will disappear in the crowd',
                    2: 'Use this hashtag to get seen over time',
                    3: 'Use this hashtag to get seen now',
                    4: 'Only good for Instagram',
                    5: 'Banned on Instagram. Don\'t use this hashtag there'
                },
                texts: {
                    0: '#underused',
                    1: '#overused',
                    2: '#long life',
                    3: '#hot now',
                    4: '#only for Instagram',
                    5: '#banned on Instagram'
                }
            }
        },
        computed: {
            tagClass () {
                return {
                    'unused-hashtag': this.color === 0,
                    'overused-hashtag': this.color === 1,
                    'poor-hashtag': this.color === 2,
                    'good-hashtag': this.color === 3,
                    'instagram-hashtag':  this.color === 4,
                    'instagram-banned-hashtag': this.color === 5,
                    'box-hashtag': true,
                    'selected-hashtag': this.selected
                }
            },
            tooltipText() {
                return this.tooltips[this.color]
            },
            hashtagText() {
                if (this.hashtag) {
                    return '#' + this.hashtag
                }
                return this.texts[this.color]
            }
        }
    }
</script>

<style scoped lang="scss">


    .box-hashtag {
        cursor: pointer;
        display: inline-block;
        background-image: none;
        color: #ffffff;
        border-radius: 0;
        padding: 0 5px 0 0;
        font-size: 14px;
        margin: 0px;

        span {
            line-height: 1.8em;
        }
        span.text {
            margin-left: 5px;
        }
    }

    .good-hashtag {
        background-color: $good;

    }

    .poor-hashtag {
        background-color: $poor;
    }

    .instagram-hashtag {
        background: $instagram-moz;
        background: $instagram-webkit;
        background: $instagram;
    }

    .overused-hashtag {
        background-color: $overused;
    }

    .unused-hashtag {
       background-color: $unused;

    }

    .instagram-banned-hashtag {
       background-color: $instagram-banned;


    }
</style>
